import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import YouTubePlayer from './YouTubePlayer';
import Scene7Player from './Scene7Player';
import VideoPlayerForiOS from './VideoPlayerForiOS';
import { selectFeatureFlags } from '../../selectors/ContextSelector';

const PROVIDER = {
    YOUTUBE: 'YOUTUBE',
    SCENE7: 'SCENE7',
    ADOBE: 'ADOBE',
};

const VideoPlayer = (props) => {
    const [posterWidth, setPosterWidth] = useState(null);
    const [posterHeight, setposterHeight] = useState(null);
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const {
        playerProps: { url: videoId = '' } = {},
        playerId: index = 0,
        videoAutoplay = false,
        videoTheme = '',
        componentType = '',
        deviceType,
        provider,
        width,
        height,
        automationId,
    } = props;
    const renderCustomVideoPlayer =
        componentType === 'JCPStoryVideoEdgeToEdge' &&
        !deviceType.isDesktop &&
        featureFlags.enableEdgeToEdgeCustomPlayer;

    const playerProps = {
        index,
        videoId,
        videoAutoplay,
        videoTheme,
        posterHeight,
        posterWidth,
        isEdgeToEdgeCustomPlayer: renderCustomVideoPlayer,
        ...props,
    };

    const [Player, setPlayer] = useState(
        props.provider === PROVIDER.YOUTUBE ? (
            <YouTubePlayer {...playerProps} />
        ) : (
            <Scene7Player {...playerProps} />
        )
    );

    let videoPlayerRef = useRef();

    /* istanbul ignore next */
    useEffect(() => {
        const posterWidth = parseInt(width || videoPlayerRef.getBoundingClientRect().width, 10);
        const posterHeight = deviceType?.isTablet
            ? 'calc(50vw - 25px)'
            : parseInt(height || videoPlayerRef.getBoundingClientRect().height, 10);

        if (
            (findMobileOS() === 'iOS' || renderCustomVideoPlayer) &&
            provider !== PROVIDER.YOUTUBE
        ) {
            setPosterWidth(posterWidth);
            setposterHeight(posterHeight);
            setPlayer(() => <VideoPlayerForiOS {...playerProps} />);
        }
    }, []);

    const isStoryVideoComponent =
        componentType === 'JCPStoryVideo' || componentType === 'JCPStoryVideoEdgeToEdge';

    return (
        <div
            className={`${
                isStoryVideoComponent ? dt(['h-0', 'pt-[56.25%]']) : dt(['h-full'])
            } ${dt(['flex', 'w-full', 'relative'])}`}
            ref={(node) => {
                videoPlayerRef = node;
            }}
            data-automation-id={automationId}
        >
            {Player}
        </div>
    );
};

VideoPlayer.propTypes = {
    provider: PropTypes.oneOf([PROVIDER.YOUTUBE, PROVIDER.SCENE7, PROVIDER.ADOBE]),
    playerProps: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    videoAutoplay: PropTypes.bool,
    videoTheme: PropTypes.string,
    isResponsive: PropTypes.bool,
    deviceType: PropTypes.object,
    isPDP: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
    componentType: PropTypes.string,
    setVideoLoaded: PropTypes.func,
    loop: PropTypes.bool,
    automationId: PropTypes.string,
};

VideoPlayer.defaultProps = {
    isResponsive: false,
    isPDP: false,
    videoAutoplay: false,
    setVideoLoaded: null,
    loop: false,
    automationId: '',
};

export default VideoPlayer;
